/**
 * Constants for Lenis smooth scroll feature
 */

export const DEFAULT_LENIS_CONFIG = {
  duration: 1,
  easing: (t: number) => 1 - Math.pow(1 - t, 4),
  baseWheel: 1,
  baseTouch: 1,
  syncTouchLerp: 0.1,
} as const
